import { UntypedFormBuilder } from '@angular/forms';
import { FormGroupBase } from '../../ng-shared/components/form/form-group-base'
import { CampoFormulario} from '../../ng-shared/components/form/campo-formulario'

export class VisualizadorFormGroup  extends FormGroupBase
{
    public static readonly justificativa: CampoFormulario = new CampoFormulario({name: 'justificativa', placeHolder: 'Justificativa da assinatura ou da rejeição da assinatura', minLength:0, maxLength: 4000});
    public static readonly situacaoTramite: CampoFormulario = new CampoFormulario({name: 'situacaoTramite', placeHolder: 'Situacao do trâmite', required: true});
    public static readonly dataDocumento: CampoFormulario = new CampoFormulario({name: 'dataDocumento', placeHolder: 'Data do documento', required: true});
    public static readonly descricao: CampoFormulario = new CampoFormulario({name: 'descricao', placeHolder: 'Descri&ccedil;&atilde;o', required: true});
    public static readonly titulo: CampoFormulario = new CampoFormulario({name: 'titulo', placeHolder: 'Título', required: true});
         
    
    public criarFormGroup(formBuilder: UntypedFormBuilder) {
        return formBuilder.group({
            [VisualizadorFormGroup.situacaoTramite.name]: ['', VisualizadorFormGroup.situacaoTramite.getValidators()],
            [VisualizadorFormGroup.dataDocumento.name]: ['', VisualizadorFormGroup.dataDocumento.getValidators()],
            [VisualizadorFormGroup.descricao.name]: ['', VisualizadorFormGroup.descricao.getValidators()],
            [VisualizadorFormGroup.titulo.name]: ['', VisualizadorFormGroup.titulo.getValidators()],
            [VisualizadorFormGroup.justificativa.name] : ['', VisualizadorFormGroup.justificativa.getValidators()]    
        });
    }

    constructor(formBuilder: UntypedFormBuilder)
    {
        super(formBuilder);
    }

    get campos() { return VisualizadorFormGroup; }

}